// import MuiCheckbox from '@mui/material/Checkbox';
import MuiFormControl from '@mui/material/FormControl';
import styled from 'styled-components';

export const FormControl = styled(MuiFormControl)`
    .MuiFormLabel-root {
        ${(props) => props.theme.typography.h3}
        color: ${(props) => props.theme.palette.textMain};
        margin-bottom: 24px;
    }
    .MuiFormControlLabel-root {
        margin-bottom: 10px;
        margin-right: 8px;
    }
    .MuiTypography-root {
        ${(props) => props.theme.typography.smallTextBold}
        color: ${(props) => props.theme.palette.textLight};
    }
    .MuiRadio-root {
        &.Mui-checked {
            font-weight: 700;
            color: ${(props) => props.theme.palette.primaryA1};
        }
    }
    .MuiButtonBase-root {
        padding: 0;
        margin: 0 8px 0 9px;
        ${(props) => props.theme.breakpointTo.md} {
            margin-right: 4px;
        }
    }
    .MuiSvgIcon-root {
        width: 29px;
        height: 29px;
    }
`;
